// Country metadata for the News section.
export const countryMeta = {
  uae: {
    name: 'UAE',
    fullName: 'United Arab Emirates',
    slug: 'uae',
    flag: '🇦🇪',
    flagCode: 'ae',
    subtitle: 'Federal Tax Authority updates & announcements',
  },
  ksa: {
    name: 'KSA',
    fullName: 'Kingdom of Saudi Arabia',
    slug: 'ksa',
    flag: '🇸🇦',
    flagCode: 'sa',
    subtitle: 'ZATCA tax news & regulatory updates',
  },
  kuwait: {
    name: 'Kuwait',
    fullName: 'Kuwait',
    slug: 'kuwait',
    flag: '🇰🇼',
    flagCode: 'kw',
    subtitle: 'Kuwait Government Online announcements & updates',
  },
  qatar: {
    name: 'Qatar',
    fullName: 'Qatar',
    slug: 'qatar',
    flag: '🇶🇦',
    flagCode: 'qa',
    subtitle: 'General Tax Authority news & updates',
  },
  oman: {
    name: 'Oman',
    fullName: 'Oman',
    slug: 'oman',
    flag: '🇴🇲',
    flagCode: 'om',
    subtitle: 'Oman Tax Authority updates & news',
  },
  bahrain: {
    name: 'Bahrain',
    fullName: 'Bahrain',
    slug: 'bahrain',
    flag: '🇧🇭',
    flagCode: 'bh',
    subtitle: 'National Bureau for Revenue news & updates',
  },
}

export const countryOrder = ['uae', 'ksa', 'kuwait', 'qatar', 'oman', 'bahrain']

export const getCountryBySlug = (slug) => {
  const normalized = slug?.toLowerCase()
  return countryMeta[normalized] || null
}
